var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Csv",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.364 44.7h17.235c1.3 0 2.377-1.088 2.377-2.4a2.378 2.378 0 0 0-2.377-2.368H22.364a2.378 2.378 0 0 0-2.377 2.368c0 1.312 1.078 2.4 2.377 2.4zm10.709-15.203h-10.71c-1.298 0-2.375 1.088-2.375 2.4a2.378 2.378 0 0 0 2.376 2.368h10.709c1.299 0 2.376-1.056 2.376-2.368 0-1.312-1.077-2.4-2.376-2.4zm22.609-7.015c.744-.009 1.555-.018 2.292-.018.792 0 1.426.64 1.426 1.44v25.728C59.4 57.568 53.032 64 45.174 64h-25.22C11.717 64 5 57.248 5 48.928V14.432C5 6.496 11.4 0 19.29 0h16.918a1.46 1.46 0 0 1 1.457 1.472v10.304c0 5.856 4.785 10.656 10.583 10.688 1.354 0 2.548.01 3.593.019.813.007 1.535.013 2.173.013.45 0 1.035-.007 1.668-.014zm.872-4.671c-2.604.01-5.674 0-7.882-.022-3.504 0-6.39-2.916-6.39-6.455V2.9c0-1.38 1.656-2.064 2.604-1.069l6.42 6.743 6.335 6.656c.925.97.247 2.579-1.087 2.582z",
    fill: "url(#y1w2bjj4ha)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "y1w2bjj4ha",
    x1: 5,
    y1: 0,
    x2: 5,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.fa5771a8.svg";
export { ForwardRef as ReactComponent };